import { render, staticRenderFns } from "./HemophiliaA-and-B-Severity.vue?vue&type=template&id=d177f2ec"
import script from "./HemophiliaA-and-B-Severity.vue?vue&type=script&lang=ts"
export * from "./HemophiliaA-and-B-Severity.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports